/**
 * The course tab strip.
 *
 * Classroom's four tabs (Stream / Classwork / People / Grades) come first, in
 * Classroom's order, then the Canvas concepts Classroom has no page for and the
 * C-GC original. That split is brainstorm.md decision 1.9: 1:1 on design
 * language, superset on page inventory. Hiding Modules to preserve an aesthetic
 * rule would cripple the app, since Modules are how many Canvas courses are
 * actually organized.
 *
 * In its own module so the layout file only exports components, which keeps
 * React Fast Refresh working.
 */
export interface CourseTab {
  /** Path segment after /c/:courseId. Empty string is the course root. */
  segment: string;
  label: string;
  /** True for pages Classroom itself has. */
  classroomNative: boolean;
}

export const COURSE_TABS: CourseTab[] = [
  { segment: '', label: 'Stream', classroomNative: true },
  { segment: 'classwork', label: 'Classwork', classroomNative: true },
  { segment: 'people', label: 'People', classroomNative: true },
  { segment: 'grades', label: 'Grades', classroomNative: true },
  { segment: 'modules', label: 'Modules', classroomNative: false },
  { segment: 'files', label: 'Files', classroomNative: false },
  { segment: 'discussions', label: 'Discussions', classroomNative: false },
  { segment: 'syllabus', label: 'Syllabus', classroomNative: false },
  { segment: 'calculator', label: 'Grade calculator', classroomNative: false },
];

/** Which tab the current URL belongs to, tolerating nested detail routes. */
export function activeSegment(pathname: string, courseId: string): string {
  const prefix = `/c/${courseId}`;
  const rest = pathname.startsWith(prefix) ? pathname.slice(prefix.length).replace(/^\//, '') : '';
  const first = rest.split('/')[0] ?? '';
  return COURSE_TABS.some((tab) => tab.segment === first) ? first : '';
}
